export function applicationTitle({ colors }) {
    return {
        prefix: {
            color: colors.text.applicationTitlePrefix
        },
        title: {
            color: colors.text.applicationTitle,
            textTransform: "uppercase"
        }
    };
}
